import React, { Component } from "react";
import { connect } from "react-redux";
import CustomerRx from "./CustomerRx";
import DoctorRx from "./DoctorRx";
import { RXWrapperContainer } from "./stylingRx.styled";

export class RxWrapper extends Component {
  render() {
    return (
      <RXWrapperContainer>
        <DoctorRx
          toggleVisible={this.props.toggleVisible}
          dataImg={this.props.customerRxImgs}
          dataPdf={this.props.customerRxPdfs}
          viewCurrPDF={this.props.viewCurrPDF}
          type={1}
        />

        <DoctorRx
          toggleVisible={this.props.toggleVisible}
          dataImg={this.props.doctorRxImgs}
          dataPdf={this.props.doctorRxPdfs}
          viewCurrPDF={this.props.viewCurrPDF}
          type={2}
        />
      </RXWrapperContainer>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RxWrapper);
